import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { Stack } from "@mui/material";
import { NavigationTabs } from "components/User-management/NavigationTabs/NavigationTabs";
import { Contacts } from "components/User-management/Contacts/Contacts";
import { Users } from "components/User-management/Users/Users";
import { Routes } from "constants/routes";

// import { useNavigationHooks } from "hooks";

// import { CreateEntity } from "components/User-management";

export const UserManagement: React.FC = () => {
  // const [createEntity, setCreateEntity] = useState<boolean>(false);

  // const { pathname } = useLocation();
  // const { setParams } = useNavigationHooks();

  // const currentTab = useMemo(() => {
  //   if (matchPath(pathname, Routes.users)) {
  //     return {
  //       title: "Add User",
  //       action: () => setParams({ search: { userManagement: "create" } })
  //     };
  //   }
  //   // if (matchPath(pathname, Routes.teams)) {
  //   //   return {
  //   //     title: "+ Add team",
  //   //     action: () => setParams({ search: { teamManagement: "new" } })
  //   //   };
  //   // }
  //   // if (matchPath(pathname, Routes.investmentEntities)) {
  //   //   return {
  //   //     title: "+ Add entity",
  //   //     action: () => setCreateEntity(true)
  //   //   };
  //   // }
  // }, [pathname]);

  return (
    <>
      <Stack
        sx={{
          bgcolor: "#f6f8fc",
          flexGrow: 1,
          gap: "20px",
          borderRadius: "8px",
          padding: "0 !important",
          overflow: "hidden"
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <NavigationTabs />
          {/* <Button variant="contained" onClick={currentTab?.action}>
            {currentTab?.title}
          </Button> */}
        </Stack>
        <Switch>
          <Redirect exact from={Routes.usersManagement} to={Routes.users} />
          <Route path={Routes.users} render={() => <Users />} />
          <Route path={Routes.contacts} render={() => <Contacts />} />
          {/* <Route path={Routes.teams} render={() => <Teams />} />
          <Route path={Routes.investmentEntities} component={Entities} /> */}
        </Switch>
      </Stack>
      {/* <CreateEntity isOpen={createEntity} handleClose={() => setCreateEntity(false)} /> */}
    </>
  );
};
